"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState, type JSX } from "react";
import GroupCreate from "./create/GroupCreate";
import { AuthContext } from "@/components/auth/Auth";
import GroupsPageListWrapper from "./GroupsPageListWrapper";
import { usePathname, useSearchParams, useRouter } from "next/navigation";
import { useSetTitle } from "@/contexts/TitleContext";
enum GroupsViewMode {
  CREATE = "CREATE",
  VIEW = "VIEW",
}
const GROUP_EDIT_SEARCH_PARAM = "edit";
export default function Groups() {
  const $ = _c(39);
  useSetTitle("Groups | Network");
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();
  const {
    connectedProfile,
    requestAuth,
    activeProfileProxy
  } = useContext(AuthContext);
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams?.get(GROUP_EDIT_SEARCH_PARAM);
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const edit = t0;
  const [viewMode, setViewMode] = useState(GroupsViewMode.VIEW);
  let t1;
  if ($[2] !== pathname || $[3] !== requestAuth || $[4] !== router) {
    t1 = async mode => {
      if (mode === GroupsViewMode.CREATE) {
        const {
          success
        } = await requestAuth();
        if (!success) {
          return;
        }
      } else {
        if (pathname) {
          router.replace(pathname);
        }
      }
      setViewMode(mode);
    };
    $[2] = pathname;
    $[3] = requestAuth;
    $[4] = router;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const onViewModeChange = t1;
  let t2;
  if ($[6] !== activeProfileProxy || $[7] !== connectedProfile?.handle || $[8] !== edit || $[9] !== onViewModeChange) {
    t2 = () => {
      if (edit && !!connectedProfile?.handle && !activeProfileProxy) {
        onViewModeChange(GroupsViewMode.CREATE);
      }
    };
    $[6] = activeProfileProxy;
    $[7] = connectedProfile?.handle;
    $[8] = edit;
    $[9] = onViewModeChange;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== edit) {
    t3 = [edit];
    $[11] = edit;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  useEffect(t2, t3);
  let t4;
  if ($[13] !== activeProfileProxy || $[14] !== connectedProfile?.handle || $[15] !== onViewModeChange) {
    t4 = () => {
      if (!connectedProfile?.handle || activeProfileProxy) {
        onViewModeChange(GroupsViewMode.VIEW);
      }
    };
    $[13] = activeProfileProxy;
    $[14] = connectedProfile?.handle;
    $[15] = onViewModeChange;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== activeProfileProxy || $[18] !== connectedProfile) {
    t5 = [connectedProfile, activeProfileProxy];
    $[17] = activeProfileProxy;
    $[18] = connectedProfile;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  useEffect(t4, t5);
  let t6;
  if ($[20] !== onViewModeChange) {
    t6 = <GroupsPageListWrapper onCreateNewGroup={() => onViewModeChange(GroupsViewMode.CREATE)} />;
    $[20] = onViewModeChange;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== onViewModeChange) {
    t7 = () => onViewModeChange(GroupsViewMode.VIEW);
    $[22] = onViewModeChange;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  const t8 = edit ?? "new";
  let t9;
  if ($[24] !== t7 || $[25] !== t8) {
    t9 = <GroupCreate onCompleted={t7} edit={t8} />;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t6 || $[28] !== t9) {
    t10 = {
      [GroupsViewMode.VIEW]: t6,
      [GroupsViewMode.CREATE]: t9
    };
    $[27] = t6;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  const components = t10;
  let t11;
  if ($[30] !== onViewModeChange || $[31] !== viewMode) {
    t11 = viewMode === GroupsViewMode.CREATE && <button onClick={() => onViewModeChange(GroupsViewMode.VIEW)} type="button" className="tw-py-2 tw-px-2 -tw-ml-2 tw-flex tw-items-center tw-gap-x-2 tw-justify-center tw-text-sm tw-font-semibold tw-border-0 tw-rounded-lg tw-transition tw-duration-300 tw-ease-out tw-cursor-pointer tw-text-iron-400 tw-bg-transparent hover:tw-text-iron-50"><svg className="tw-flex-shrink-0 tw-w-5 tw-h-5" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M20 12H4M4 12L10 18M4 12L10 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg><span>Back</span></button>;
    $[30] = onViewModeChange;
    $[31] = viewMode;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== t11) {
    t12 = <div className="tailwind-scope">{t11}</div>;
    $[33] = t11;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <h1>Groups</h1>;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  const t14 = components[viewMode];
  let t15;
  if ($[36] !== t12 || $[37] !== t14) {
    t15 = <div>{t12}{t13}{t14}</div>;
    $[36] = t12;
    $[37] = t14;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  return t15;
}